import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import CompanyDxDiagnosisQuestionForm from '@src/features/company/dx-diagnosis/DxDiagnosisQuestion';
import CompanyNoMenusLayout from '@src/layouts/company/CompanyNoMenusLayout';
import Error404 from '@src/pages/Error404';
import { useState } from 'react';

function CompanyDxDiagnosisQuestion() {
  const [isUnansweredPage, setIsUnansweredPage] = useState(false);

  return (
    <CompanyGuard
      canRoles={[COMPANY_ROLE.ADMIN]}
      canService={[SERVICE.DX_DIAGNOSIS]}
    >
      {isUnansweredPage ? (
        <Error404 isTenant={false} />
      ) : (
        <CompanyNoMenusLayout showLogo={true}>
          <CommonHelmet />
          <CompanyDxDiagnosisQuestionForm onUnansweredPage={() => setIsUnansweredPage(true)} />
        </CompanyNoMenusLayout>
      )}
    </CompanyGuard>
  );
}

export default CompanyDxDiagnosisQuestion;
